import env from './env';

export const KEYCLOAK_ENDPOINTS = {
  TOKEN: `${env.KEYCLOAK_URL}/realms/${env.KEYCLOAK_REALM}/protocol/openid-connect/token`,
  LOGOUT: `${env.KEYCLOAK_URL}/realms/${env.KEYCLOAK_REALM}/protocol/openid-connect/logout`,
  ADMIN_GROUPS: `${env.KEYCLOAK_URL}/admin/realms/${env.KEYCLOAK_REALM}/groups`,
  AGENTS_GROUP: `${env.KEYCLOAK_URL}/admin/realms/${env.KEYCLOAK_REALM}/groups/${env.AGENTS_GROUP_ID}`,
  TELLERS_GROUP: `${env.KEYCLOAK_URL}/admin/realms/${env.KEYCLOAK_REALM}/groups/${env.TELLERS_GROUP_ID}`,
};

export const API_ENDPOINTS = {
  // Dashboard
  DASHBOARD_STATS: '/dashboard/stats',

  // Customers
  CUSTOMERS: '/customers',
  CUSTOMER_BY_ID: (id) => `/customers/${id}`,

  // Travel Card Holders
  TRAVEL_CARD_HOLDERS: '/travel-card-holders',
  TRAVEL_CARD_HOLDER_BY_ID: (id) => `/travel-card-holders/${id}`,

  // Payments
  PAYMENTS: '/payments',
  PAYMENTS_FILTERED: '/payments/all-payments-filtered',
  PAYMENT_BY_ID: (id) => `/payments/${id}`,

  // Invoices
  INVOICES: '/invoices',
  INVOICE_BY_ID: (id) => `/invoices/${id}`,

  // Tellers
  TELLERS: '/tellers',
  TELLER_BY_ID: (id) => `/tellers/${id}`,

  // Tills
  COLLECTION_POINTS: '/collection-points',
  COLLECTION_POINT_BY_ID: (id) => `/collection-points/${id}`,
  TILL_SESSIONS: '/till-sessions',
  TILL_SESSION_BY_ID: (id) => `/till-sessions/${id}`,

  // Fleet
  BUSES: '/buses',
  BUS_BY_ID: (id) => `/buses/${id}`,
  ROUTES: '/routes',
  ROUTE_BY_ID: (id) => `/routes/${id}`,
  DRIVERS: '/drivers',
  DRIVER_BY_ID: (id) => `/drivers/${id}`,
  VALIDATORS: '/validators',
  VALIDATOR_BY_ID: (id) => `/validators/${id}`,
  TRANSPORTERS: '/transporters',
  TRANSPORTER_BY_ID: (id) => `/transporters/${id}`,

  // Rosters
  BUS_ROSTERS: '/rosters/buses',
  VALIDATOR_ROSTERS: '/rosters/validators',

  // Products
  PRODUCTS: '/products',
  PRODUCT_BY_ID: (id) => `/products/${id}`,

  // Orders
  ORDERS: '/orders',
  ORDER_BY_ID: (id) => `/orders/${id}`,

  // Sales
  SALES_SESSIONS: '/sales-sessions',

  // Accounting
  ACCOUNTS: '/accounts',
  ACCOUNT_BY_ID: (id) => `/accounts/${id}`,
  JOURNALS: '/journals',
  JOURNAL_BY_ID: (id) => `/journals/${id}`,
  BANKS: '/banks',
  BANK_BY_ID: (id) => `/banks/${id}`,

  // Reports
  REPORTS_DAILY: '/reports/daily',
  REPORTS_WEEKLY: '/reports/weekly',
  REPORTS_CUSTOM: '/reports/custom',
};
